import { mockRpc } from './mock.js';

const USE_MOCK = import.meta.env?.VITE_USE_MOCK === '1';
const URL = import.meta.env?.VITE_SUPABASE_URL;
const KEY = import.meta.env?.VITE_SUPABASE_ANON_KEY;

// Memoise the promise, not the resolved client: concurrent first calls would
// otherwise both pass the null check and each build a client.
let supabase = null;
function real() {
  if (!supabase) {
    supabase = import('@supabase/supabase-js').then(({ createClient }) =>
      createClient(URL, KEY, { auth: { persistSession: false } }),
    );
  }
  return supabase;
}

export async function rpc(fn, args = {}) {
  if (USE_MOCK) return mockRpc(fn, args);
  const client = await real();
  const { data, error } = await client.rpc(fn, args);
  if (error) throw new Error(error.message || 'rpc failed');
  return data;
}
